import { render, staticRenderFns } from "./streets.vue?vue&type=template&id=499a63c8&scoped=true"
import script from "./streets.vue?vue&type=script&lang=js"
export * from "./streets.vue?vue&type=script&lang=js"
import style0 from "./streets.vue?vue&type=style&index=0&id=499a63c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499a63c8",
  null
  
)

export default component.exports